module.exports = __webpack_public_path__ + "static/media/table.aacfb4e2.png";